import { render, staticRenderFns } from "./ShowMedia.vue?vue&type=template&id=7c07314f&scoped=true&"
import script from "./ShowMedia.vue?vue&type=script&lang=js&"
export * from "./ShowMedia.vue?vue&type=script&lang=js&"
import style0 from "./ShowMedia.vue?vue&type=style&index=0&id=7c07314f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c07314f",
  null
  
)

export default component.exports